(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabOnEventScriptsDeleteController', TabOnEventScriptsDeleteController);

    TabOnEventScriptsDeleteController.$inject = ['$uibModalInstance', 'scriptName'];

    function TabOnEventScriptsDeleteController($uibModalInstance, scriptName) {
        var vm = this;
        vm.getFileName = scriptName;
        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (scriptName) {
            $uibModalInstance.close(scriptName);
        };
    }
})();
